// extracted by mini-css-extract-plugin
export default {"contact":"Style_contact__c-xVJ","fullWidth":"Style_fullWidth__8Dne7"};